import { useAuthStore } from '@terminal/stores/use-auth/store/authStore';

export const LAST_USED_CHART_PARAMS = 'LAST_USED_CHART_PARAMS';
export const LAST_USED_SCREENER_URL = 'LAST_USED_SCREENER_URL';

export type LastUsedUrlKey =
  | typeof LAST_USED_CHART_PARAMS
  | typeof LAST_USED_SCREENER_URL;

const getUserScopedKey = (key: LastUsedUrlKey) => {
  const userId = useAuthStore.getState().user_id;
  return userId ? `${key}_${userId}` : undefined;
};

export const saveLastUsedUrl = (key: LastUsedUrlKey, url: string) => {
  const scopedKey = getUserScopedKey(key);

  if (!scopedKey) {
    return;
  }

  try {
    localStorage.setItem(scopedKey, url);
  } catch {
    // no-op
  }
};

export const readLastUsedUrl = (key: LastUsedUrlKey): string | undefined => {
  const scopedKey = getUserScopedKey(key);

  if (!scopedKey) {
    return undefined;
  }

  try {
    return localStorage.getItem(scopedKey) ?? undefined;
  } catch {
    return undefined;
  }
};

export const removeLastUsedUrl = (key: LastUsedUrlKey) => {
  const scopedKey = getUserScopedKey(key);

  if (!scopedKey) {
    return;
  }

  try {
    localStorage.removeItem(scopedKey);
  } catch {
    // no-op
  }
};
